"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findNumberOfNodes = exports.findNodesWithWrongContext = exports.getPreviousNodes = exports.addRefIdsToNodes = exports.getAncestors = exports.getSkippedNodes = void 0;
var lodash_1 = require("lodash");
var constants_1 = require("../constants");
function getSkippedNodes(ql, ancestors, idToIndexMap, subNodes) {
    var entryNodeId = lodash_1.get(ql, 'entryPoint.statements[0].outcome.params.id', constants_1.FinalNode);
    var entryNodeIndex = idToIndexMap[entryNodeId];
    var skippedNodes = [];
    ancestors.forEach(function (previousNodes, nodeIndex) {
        if (nodeIndex !== 0 &&
            nodeIndex !== entryNodeIndex &&
            !subNodes[nodeIndex] &&
            !previousNodes.includes(entryNodeIndex)) {
            skippedNodes.push(nodeIndex);
        }
    });
    return skippedNodes;
}
exports.getSkippedNodes = getSkippedNodes;
function traverse(ancestor, parent, adjacencyList, paths, cyclicNodes) {
    if (!(parent in adjacencyList)) {
        return;
    }
    for (var _i = 0, _a = adjacencyList[parent]; _i < _a.length; _i++) {
        var child = _a[_i];
        var childArray = paths[child];
        // cyclicNodes from nodes(keys), to (values) target nodes
        if (paths[parent].includes(child)) {
            if (!cyclicNodes[parent]) {
                cyclicNodes[parent] = new Set();
            }
            cyclicNodes[parent].add(child);
            continue;
        }
        if (childArray.length === 0 ||
            childArray[childArray.length - 1] !== ancestor) {
            childArray.push(ancestor);
            traverse(ancestor, child, adjacencyList, paths, cyclicNodes);
        }
    }
}
function getAncestors(adjacencyList, idToIndexMap, subNodes) {
    var nodes = Object.values(idToIndexMap).filter(function (id) { return !subNodes[id]; });
    var maxIndexNumber = nodes.length > 0 ? Math.max.apply(Math, nodes) + 1 : 0;
    var list = cleanAdjacencyList(adjacencyList);
    var nodesLength = nodes.length;
    var ancestors = new Array(maxIndexNumber).fill(undefined).map(function () { return []; });
    var cyclicNodes = {};
    for (var i = 0; i < nodesLength; i++) {
        traverse(nodes[i], nodes[i], list, ancestors, cyclicNodes);
    }
    return {
        ancestors: ancestors,
        cyclicNodes: cyclicNodes,
    };
}
exports.getAncestors = getAncestors;
// remove end node from adjacencyList
function cleanAdjacencyList(list) {
    return Object.keys(list).reduce(function (accumulator, nodeId) {
        var cleanNodes = list[nodeId].filter(function (id) { return id !== 0; });
        if (cleanNodes.length > 0) {
            accumulator[nodeId] = cleanNodes;
        }
        return accumulator;
    }, {});
}
function addRefIdsToNodes(nodes, indexToIdMap) {
    return nodes.map(function (indexedId) { return indexToIdMap[indexedId]; });
}
exports.addRefIdsToNodes = addRefIdsToNodes;
function attachSubNodesToPath(path, groupNodes) {
    return path.reduce(function (accumulator, id) {
        if (groupNodes[id]) {
            accumulator.push.apply(accumulator, groupNodes[id]);
        }
        accumulator.push(id);
        return accumulator;
    }, []);
}
function filterSkippedNodesAddGroupSubNodes(ancestors, skippedNodes, groupNodes) {
    return ancestors.map(function (path) {
        return attachSubNodesToPath(path.filter(function (nodeIndex) { return !skippedNodes.includes(nodeIndex); }), groupNodes);
    });
}
function getPreviousNodes(ancestors, indexToIdMap, skippedNodes, groupNodes, subNodes) {
    var allAncestors = filterSkippedNodesAddGroupSubNodes(ancestors, skippedNodes, groupNodes);
    return indexToIdMap.reduce(function (accumulator, nodeRefId, nodeIndex) {
        if (skippedNodes.includes(nodeIndex)) {
            return accumulator;
        }
        if (subNodes[nodeIndex]) {
            var groupIndex = subNodes[nodeIndex];
            var allSubNodesInGroup = groupNodes[groupIndex];
            var previousSubNodes = allSubNodesInGroup.slice(0, allSubNodesInGroup.indexOf(nodeIndex));
            accumulator[nodeRefId] = addRefIdsToNodes(attachSubNodesToPath(__spreadArrays(ancestors[groupIndex], previousSubNodes), groupNodes), indexToIdMap);
        }
        else {
            var ancestorNodes = allAncestors[nodeIndex];
            var isGroupNode = !!groupNodes[nodeIndex];
            if (isGroupNode) {
                ancestorNodes.push.apply(ancestorNodes, groupNodes[nodeIndex]);
            }
            accumulator[nodeRefId] = addRefIdsToNodes(ancestorNodes, indexToIdMap);
        }
        return accumulator;
    }, {});
}
exports.getPreviousNodes = getPreviousNodes;
function findNodesWithWrongContext(ancestors, referencingAdjacencyList, indexToIdMap) {
    return indexToIdMap.reduce(function (accumulator, nodeRefId, nodeIndex) {
        var referencedNodes = referencingAdjacencyList[nodeIndex] || [];
        var unansweredNode = referencedNodes.find(function (referencedNode) { return !ancestors[nodeIndex].includes(referencedNode); });
        if (unansweredNode) {
            var unansweredNodeRefId = indexToIdMap[unansweredNode];
            accumulator[nodeRefId] = accumulator[nodeRefId]
                ? __spreadArrays(accumulator[nodeRefId], [unansweredNodeRefId]) : [unansweredNodeRefId];
        }
        return accumulator;
    }, {});
}
exports.findNodesWithWrongContext = findNodesWithWrongContext;
function findNumberOfNodes(nodes) {
    return nodes.reduce(function (accumulator, node) {
        if (node.nodes) {
            return accumulator + 1 + node.nodes.length;
        }
        return accumulator + 1;
    }, 0);
}
exports.findNumberOfNodes = findNumberOfNodes;
